import React from 'react';
import { CollapsiblePanel } from '../../../common/collapsible-panel/collapsible-panel.react';
import IntentList, { type IntentT } from '../intent-list/intent-list';
type PropsT = {
  intentArr: IntentT[];
  onIntentSelect: (intent: IntentT) => void;
  currentIntent?: IntentT | null;
  addNewIntent?: (intent: string) => void;
};
const IntentPanel = ({
  intentArr,
  onIntentSelect,
  currentIntent,
  addNewIntent
}: PropsT) => {
  return <CollapsiblePanel title={'Intents'}>
      <IntentList intentArr={intentArr} onIntentSelect={onIntentSelect} currentIntent={currentIntent} addNewIntent={addNewIntent} />
    </CollapsiblePanel>;
};
export default IntentPanel;